import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Card } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  loadCardMovements,
  LOAD_CARD_MOVEMENTS
} from 'src/store/actions/cardMovementsActions';
import {
  selectCardMovementsList,
  selectCardMovementsCount,
  selectCardMovementsQueryOptions
} from 'src/store/selectors/cardMovementsSelectors';
import Toolbar from './Toolbar';
import CardMovementsTable from './CardMovementsTable';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CardMovementsList = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const movements = useSelector(selectCardMovementsList);
  const count = useSelector(selectCardMovementsCount);
  const { page } = useSelector(selectCardMovementsQueryOptions);
  const loading = useSelector(isLoadingSelector([LOAD_CARD_MOVEMENTS.action]));
  const success = useSelector(successSelector([LOAD_CARD_MOVEMENTS.action]));

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadCardMovements({ page: value }));
    },
    [dispatch]
  );

  return (
    <Page className={classes.root} title={t('NAVIGATION.CARD_MOVEMENTS')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            {success && !loading && count === 0 ? (
              <Card className={classes.prealoderCard}>
                <NotFoundRecords
                  title="NOT_FOUND_RECORDS_MESSAGE.CARD_MOVEMENTS_TITLE"
                  description="NOT_FOUND_RECORDS_MESSAGE.CARD_MOVEMENTS_DESCRIPTION"
                />
              </Card>
            ) : (
              <CardMovementsTable
                movements={movements}
                count={count}
                page={page}
                handleChangePage={handleChangePage}
                loading={loading}
              />
            )}
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default CardMovementsList;
